import { judgeUserAgent } from '@/utils/judgeUserAgent'
import wx from 'weixin-js-sdk'
import router from '@/router'

function onBridgeReady(data) {
  return new Promise((resolve, reject) => {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: data.appId, //公众号ID，由商户传入
        timeStamp: data.timestamp, //时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, //随机串
        package: data.package,
        signType: data.signType, //微信签名方式：
        paySign: data.paySign //微信签名
      },
      function(res) {
        let response = {
          status: false,
          cancelPay: false,
          message: '微信支付失败'
        }

        if (!res.err_msg) {
          res.err_msg = res.errMsg
        }

        response.message = res.err_msg

        if (res.err_msg.includes('fail')) {
          response.status = false
          response.message = '微信支付失败' + res.err_msg
        }

        if (res.err_msg.includes('cancel')) {
          response.status = false
          response.cancelPay = true
          response.message = '取消微信支付'
        }

        if (res.err_msg.includes('ok')) {
          response.status = true
          response.message = '微信支付成功'
        }

        // if (res.errMsg.includes('fail')) {
        //   response.status = false
        //   response.message = '微信支付失败'
        // }

        resolve(response)
      }
    )
  })
}

function wechatPaybyJssdk(data) {
  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener(
        'WeixinJSBridgeReady',
        () => {
          return onBridgeReady(data)
        },
        false
      )
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', () => {
        return onBridgeReady(data)
      })
      document.attachEvent('onWeixinJSBridgeReady', () => {
        return onBridgeReady(data)
      })
    }
  } else {
    return onBridgeReady(data)
  }
}

function wechatPayByMiniprogram (data) {
	console.log(data, 'data');
	
	if (!wx && !wx.chooseWXPay) {
		return {
			status: false,
			message: '调用微信支付失败'
		}
	}
	wx.config({
  // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  	...data
,   jsApiList: [
     "showMenuItems",
     "chooseWXPay",
   ], // 必填，需要使用的JS接口列表
 });

  return new Promise((resolve, reject) => {
    wx.ready(() => {
      wx.chooseWXPay({
        // timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        // nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
        // package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
        // signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        // paySign: data.paySign, // 支付签名
        // appId: data.appId, // 公众号名称，由商户传入
        ...data,
        success: res => {
          // console.log(res, 'pay');
          resolve({
            status: true,
            message: '微信支付成功'
          })
        },
        fail: res => {
          resolve({
            status: false,
            message: '微信支付失败' + res.errMsg
          })
        },
        cancel: function(res) {
          resolve({
            status: false,
            message: '取消微信支付'
          })
        }
      })
    })
	})
}


async function payByMiniprogram (data) {
  // console.log(router.app._route.fullpath)
  // 重定向
  const datas = {
    payInfo: data,
    redirectPath: router.app._route.fullPath
  }
  const paymentInfo = encodeURIComponent(
    JSON.stringify(datas)
  )
  
  // uni.webView.navigateTo({
  //   url: `/pages/payment/index?requestPayment=${paymentInfo}`
  // })

  return {
    status: false,
    message: ''
  }
}


async function wechatJsApiPay (data) {

	// console.log(judgeUserAgent('miniProgram'), judgeUserAgent('weChat'), 'miniProgram')
	// if (judgeUserAgent('weChat')) {
	// 	return await wechatPaybyJssdk(data)
	// }
  if (judgeUserAgent('miniProgram')) {
    return payByMiniprogram(data)
		// return await wechatPayByMiniprogram(data)
	} else {
		return await wechatPaybyJssdk(data)
	}
}

export default wechatJsApiPay

// {"errMsg": "chooseWXPay:fail, the permission value is offline verifying"}
